var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ManagerLeft'),_vm._v(" "),(_vm.managerComponent === 'approval')?_c('ManageApproval'):(_vm.managerComponent === 'member')?_c('ManageMember'):(_vm.managerComponent === 'contents')?_c('ManageContentsList'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35f6ed88","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/Manager.vue
// module id = 294
// module chunks = 0